'use strict'

var encode = require('./encode')
var escape = require('./escape')

module.exports = encode
encode.escape = escape
